import React, { useEffect, useState } from 'react'
import Button from '../../component/Button'
import { useLocation, useNavigate } from 'react-router-dom';
import SearchBox from '../../component/SearchBox';
import SuccessModal from '../../modalComponents/SuccessModal';
import classes from './style.module.scss';
import RewardsList from './components/RewardsList';
import ViewRewards from './components/ViewRewards';
import AddRewards from '../../modalComponents/AddRewards';
import Exported from '../../service/endpoints';
import request from '../../service';
import { Toast } from '../../service/toast';
import GetUserPermission from '../../component/GetUserPermission';

const Rewards = () => {

    const [addRewardsModal, setAddRewardsModal] = useState(false)
    const [viewRewards, setViewRewards] = useState(false)
    const [showSuccessModal, setShowSuccessModal] = useState(false)
    const [page, setPage] = useState(1);
    const [searchInput, setSearchInput] = useState('')
    const [programList, setProgramList] = useState({});
    const [sortConfig, setSortConfig] = useState(null);
    const [isLoading, setisLoading] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const addPermission = GetUserPermission({ key: 'add' });

    useEffect(() => {
        if (location?.pathname) {
            const pathName = location?.search?.split('?type=')
            const pathById = location?.search?.split('?id=')
            const params = pathName[pathName?.length - 1]
            const paramsID = pathById[pathById?.length - 1]
            if (params == 'add' || params?.includes('edit')) {
                if (params && pathName?.length > 1) {
                    setAddRewardsModal(true)
                } else {
                    setAddRewardsModal(false)
                }
            } else {
                if (paramsID && pathById?.length > 1) {
                    setViewRewards(true)
                } else {
                    setViewRewards(false)
                }
            }
        }
    }, [location])

    useEffect(() => {
        getRewardList()
    }, [page, searchInput, sortConfig])

    const getRewardList = async () => {
        setisLoading(true)
        let url = `${Exported.Endpoints.getRewards}`
        let paramsObj = {
            page: page,
            limit: 10,
        }

        if (searchInput && searchInput !== '') {
            paramsObj['search'] = searchInput
        }
        if (sortConfig) {
            paramsObj['sort'] = sortConfig?.key
            paramsObj['sortOrder'] = sortConfig?.direction
        }

        await request({
            url: url,
            params: { ...paramsObj }
        }).then((res) => {
            if (res?.data?.status) {
                const obj = {
                    result: res?.data?.data?.list,
                    pageMeta: res?.data?.data?.pageMeta
                }
                setProgramList(obj)
            }
        }).catch((err) => {
            console.log(err, "err")
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
        setisLoading(false)
    }


    const getRewardsId = () => {
        const pathName = location?.search?.split('?id=')
        if (pathName?.length > 1) {
            const params = pathName[pathName?.length - 1]
            return params
        }
        return;
    }

    const handleChange = (value) => {
        setSearchInput(value)
    }

    const handleClose = () => {
        setAddRewardsModal(false)
        redirectBack()
    }

    const handleSuccess = () => {
        handleClose()
        setShowSuccessModal(true)
    }

    const redirectBack = () => {
        navigate(`/admin/rewards`)
    }

    const redirectTo = () => {
        navigate(`?type=add`)
    }

    const handleCloseRewards = () => {
        setViewRewards(false)
        redirectBack()
    }

    const handleSuccessReward = () => {
        setAddRewardsModal(true)
        setViewRewards(false)
        redirectTo()
    }

    const handleSuccessModalClose = () => {
        setShowSuccessModal(false)
        redirectBack()
    }

    return (
        <>
            <div className={`${classes.rewardsProgramWrapper}`}>
                <div className={`w-[100%] flex items-center justify-between`}>
                    <div className={`layout-title`}>Rewards</div>
                    <div className='flex items-center'>
                        <SearchBox value={searchInput} onChange={handleChange} placeholder={'Find by reward name...'} />
                        {addPermission && <Button text={"Add Reward"} className={'ml-5 !px-4'} smallBtn onClick={() => redirectTo()} /> }
                    </div>
                </div>
                <div>
                    <RewardsList
                        rewardId={getRewardsId()}
                        sortConfig={sortConfig}
                        setSortConfig={setSortConfig}
                        setPage={setPage}
                        programList={programList}
                        isLoading={isLoading}
                        handleEdit={setAddRewardsModal}
                        getRewardList={getRewardList}
                    />
                </div>
            </div>
            {viewRewards ?
                <ViewRewards isOpen={viewRewards} closePopUp={handleCloseRewards} rewardId={getRewardsId()} getRewardList={getRewardList} handleSuccessModal={handleSuccessReward} /> : null
            }

            {addRewardsModal ?
                <AddRewards isOpen={addRewardsModal} closePopUp={handleClose} rewardId={getRewardsId()} getRewardList={getRewardList} handleSuccessModal={handleSuccess} />
                : null}
            {showSuccessModal ?
                <SuccessModal
                    isOpen={showSuccessModal}
                    closePopUp={handleSuccessModalClose}
                    successText={'Success!'}
                    boxAlign='center'
                    modalText={'New reward has been added successfully'}
                />
                : null
            }
        </>
    )
}

export default Rewards